import { Editor, Range } from 'slate';

export function isCollapsed(editor: Editor) {
    const { selection } = editor;

    return selection && Range.isCollapsed(selection);
}
